/**
 * deploy-row-site-navigate: 현장의 `dashboard_url` 하나로부터
 * admin-client / router swagger / lights swagger 3개 URL 을 파생.
 *
 * router/lights 포트는 `docker/deploy/company/docker-compose.yaml` 기준의
 * 고정값(8000/8082)이다. 운영 환경에서 포트가 바뀌면 이 파일만 수정.
 *
 * 사용 예:
 *   const urls = deriveServiceUrls('http://192.168.0.102:3000/admin');
 *   // → admin:         'http://192.168.0.102:3000/admin'
 *   //   routerSwagger: 'http://192.168.0.102:8000/swagger/index.html'
 *   //   lightsSwagger: 'http://192.168.0.102:8082/swagger/index.html'
 *
 * dashboard_url 이 비어있거나 잘못된 형식이면 세 필드 모두 null.
 * 호출부는 null 체크로 MenuItem disable / 버튼 숨김 처리한다.
 */

export interface ServiceUrls {
  admin: string | null;
  routerSwagger: string | null;
  lightsSwagger: string | null;
}

const ROUTER_PORT = 8000;
const LIGHTS_PORT = 8082;
const SWAGGER_PATH = '/swagger/index.html';

const EMPTY: ServiceUrls = { admin: null, routerSwagger: null, lightsSwagger: null };

export function deriveServiceUrls(
  dashboardUrl: string | null | undefined,
): ServiceUrls {
  if (!dashboardUrl) return EMPTY;
  try {
    const u = new URL(dashboardUrl);
    const base = `${u.protocol}//${u.hostname}`;
    return {
      admin: dashboardUrl,
      routerSwagger: `${base}:${ROUTER_PORT}${SWAGGER_PATH}`,
      lightsSwagger: `${base}:${LIGHTS_PORT}${SWAGGER_PATH}`,
    };
  } catch {
    return EMPTY;
  }
}
